import React from 'react';

const SvgComment = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      d="M4.854.043h-2.2C1.254.043 1.008 1.208.98 1.86a45.247 45.247 0 0 0 0 2.259V7.77c.002 1.002.75 1.814 1.673 1.815h3.212l2.028 2.199a.385.385 0 0 0 .445.096.445.445 0 0 0 .25-.409V9.585h.717c.923-.002 1.672-.814 1.673-1.816V1.86c0-1.003-.749-1.816-1.672-1.817H4.854zm5.31 7.726c0 .515-.384.932-.858.932H8.182c-.224 0-.407.197-.407.442v1.262L6.321 8.83a.39.39 0 0 0-.288-.13h-3.38c-.472 0-.856-.417-.857-.93V1.858c0-.515.384-.932.858-.932h6.652c.228 0 .446.098.607.273a.974.974 0 0 1 .251.659v5.91z"
    />
  </svg>
);

export default SvgComment;
